<template>
  <div class="flex items-center gap-5 text-white">
    <jazzicon
      class="h-12"
      :address="resolvedAddress"
      :diameter="48"
    />
    <span class="flex flex-col">
      <template v-if="isConnected">
        <span>
          <a :href="userAddressExplorerLink" target="_blank">
            {{ userWalletText }}
          </a>
        </span>
        <h1 class="font-bold text-white text-lg">
          {{ userTokenBalanceFormatted }} {{ tokenSymbol }}
        </h1>
        <span class="text-effect--success font-bold text-sm">
          ${{ userTokenBalanceUSDFormatted }}
        </span>
      </template>
      <div v-else>
        <Button @click="init" text="Connect Wallet" secondary small />
      </div>
    </span>
  </div>
  <Button
    text="New Loan"
    secondary
    small
    full
    class="w-full mt-3"
    @click="triggerModal"
  />
  <LoanModal v-if="openModal" @close="openModal = false" />
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { getShortAddress } from "@/factories/Utils";
import Button from "./Button.vue";
import LoanModal from "../loan/LoanModal.vue";
export default {
  name: "Wallet",

  components: {
    Button,
    LoanModal,
  },

  data() {
    return {
      openModal: false,
    };
  },

  computed: {
    ...mapGetters([
      "activeNetwork",
      "isConnected",
      "userAddress",
      "userAddressExplorerLink",
      "dexBuyLink",
      "tokenSymbol",
      "userTokenBalanceFormatted",
      "userTokenBalanceUSDFormatted",
    ]),
    ...mapState({
      addressEnsMap: ({ main }) => main.addressEnsMap,
      zeroAddress: ({ main }) => main.zeroAddress,
    }),

    resolvedAddress() {
      return this.userAddress || this.zeroAddress;
    },

    userWalletText() {
      return (
        (this.userAddress &&
          this.addressEnsMap[this.userAddress.toLowerCase()]) ||
        getShortAddress(this.resolvedAddress)
      );
    },
  },

  methods: {
    ...mapActions(["init"]),

    getShortAddress,

    triggerModal() {
      this.$store.commit(
        "SET_SELECTED_COLLATERAL_POOL",
        this.activeNetwork.contracts.mainLp
      );
      this.openModal = true;
    },
  },
};
</script>
